import { Color } from 'ng2-charts';
import { GraphPeriodType } from 'app/models';
import { MatRadioChange } from '@angular/material/radio';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chart-component',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent {
  @Input() totalCutCreaseChartDataSets: Array<ChartDataSets> = [];
  @Input() totalCutCreaseChartLabels: string[] = [];
  @Input() sumOfJobsChartLabels: string[] = [];
  @Input() sumOfJobsChartDataSets: Array<ChartDataSets> = [];
  @Input() selectedPeriod = GraphPeriodType.DAILY;

  @Output() selectedPeriodChanged = new EventEmitter<MatRadioChange>();

  graphPeriods: string[] = Object.values(GraphPeriodType);
  chartType: ChartType = 'bar';

  chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
    scales: {
      xAxes: [
        {
          gridLines: { color: 'rgba(0,0,0,0.04)' },
          ticks: { fontSize: 11, maxRotation: 45 },
        },
      ],
      yAxes: [
        {
          gridLines: { color: 'rgba(0,0,0,0.04)' },
          ticks: { min: 0, fontSize: 11 },
        },
      ],
    },
  };

  // Fabricode red — primary metric (jobs)
  sumOfJobsChartColors: Color[] = [
    {
      backgroundColor: 'rgba(230,46,41,0.75)',
      borderColor: '#e62e29',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(230,46,41,0.9)',
    },
  ];

  // Indigo — secondary metric (cut + crease)
  totalCutCreaseChartColors: Color[] = [
    {
      backgroundColor: 'rgba(99,102,241,0.65)',
      borderColor: '#6366f1',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(99,102,241,0.85)',
    },
  ];

  handeSelectedPeriodChanged(event: MatRadioChange): void {
    this.selectedPeriodChanged.emit(event);
  }
}
